import { render, staticRenderFns } from "./other-list.vue?vue&type=template&id=f8b0df3a&scoped=true&"
import script from "./other-list.vue?vue&type=script&lang=js&"
export * from "./other-list.vue?vue&type=script&lang=js&"
import style0 from "./other-list.vue?vue&type=style&index=0&id=f8b0df3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b0df3a",
  null
  
)

export default component.exports